import React from 'react';
import { Mail, Phone, Clock, MessageCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';

const Contact = () => {

  const contactInfo = [
    {
      icon: Phone,
      title: 'Call Us',
      details: ['07481 435244', 'Available 24/7'],
    },
    {
      icon: MessageCircle,
      title: 'WhatsApp',
      details: ['07481 435244', 'Quick responses', 'Chat anytime'],
    },
    {
      icon: Mail,
      title: 'Email Us',
      details: ['info@idrisexpressltd.co.uk', 'We reply within 24 hours'],
    },
    {
      icon: Clock,
      title: 'Business Hours',
      details: ['Mon - Fri: 8:00 AM - 6:00 PM', 'Saturday: 9:00 AM - 2:00 PM', 'Sunday: Closed (Emergency only)'],
    },
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Contact Us - Get a Quote | Idris Express Courier Service"
        description="Contact Idris Express for fast courier services. Call 07481 435244, WhatsApp us, or email for an instant quote. Available 24/7 for urgent deliveries."
        keywords="contact courier, get quote delivery, courier phone number, 24/7 courier service"
        canonicalUrl="https://idrisexpressltd.co.uk/contact"
      />
      {/* Hero Section */}
      <section className="bg-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Have questions? We're here to help. Get in touch with our friendly team.
          </p>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((info, index) => (
              <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-shadow">
                <CardContent className="pt-6">
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="p-4 bg-gray-100 rounded-full">
                      <info.icon className="h-8 w-8 text-gray-800" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">{info.title}</h3>
                    <div className="space-y-1">
                      {info.details.map((detail, idx) => (
                        <p key={idx} className="text-gray-600 text-sm">
                          {detail}
                        </p>
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Emergency Contact */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex justify-center space-x-8 mb-6">
            <Phone className="h-16 w-16" />
            <MessageCircle className="h-16 w-16" />
          </div>
          <h2 className="text-4xl font-bold mb-6">Need Urgent Assistance?</h2>
          <p className="text-xl text-gray-300 mb-8">
            For time-critical deliveries or emergency support, contact us now
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
            <a href="tel:07481435244" className="text-4xl font-bold hover:text-gray-300 transition-colors" aria-label="Call Idris Express Ltd Emergency Support">
              07481 435244
            </a>
            <span className="text-gray-500 hidden sm:block">|</span>
            <a href="https://wa.me/447481435244" target="_blank" rel="noopener noreferrer" className="text-2xl font-semibold hover:text-gray-300 transition-colors flex items-center" aria-label="Chat with Idris Express on WhatsApp for Emergency Support">
              <MessageCircle className="mr-2 h-6 w-6" />
              WhatsApp Us
            </a>
          </div>
          <p className="text-gray-400">Available 24 hours a day, 7 days a week</p>
        </div>
      </section>
    </div>
  );
};

export default Contact;